import { Suspense } from "react";
import Loader from "../../components/loader";
import { Routes, Route } from "react-router-dom";
import { AllFundingRoutes } from ".";


const FundingRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {AllFundingRoutes?.map((item, index) => {
          return (
            <Route key={index} exact path={item.path} element={item?.element} />
          );
        })}

        {/* <Route exact path="*" element={<PageNotFound />} /> */}
      </Routes>
    </Suspense>
  );
};

export default FundingRoutes;
